export default __webpack_public_path__ + "static/media/completed-green.bd5ddd2d.svg";